<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-12">
					<div class="account__block__title">{{ t('user.page.table.bets.title') }}</div>
				</div>
			</div>
			<div class="row" v-if="!isSimple">
				<div class="col-12">
					<date-picker
							v-model="date"
							range
							:lang="lang"
							:not-after="new Date()"
							format="DD MMMM YYYY"
							confirm
							:range-separator="'-'"
							class="account__datepicker"
					></date-picker>
				</div>
			</div>
			<div class="row" v-if="!isSimple">
				<div class="col-12 d-flex">
					<div class="btn btn-link btn-sm" @click="filtering = 'all'" :class="{ 'active': filtering === 'all'}">{{t('user.page.table.bets.btn.all')}}</div>
					<div class="btn btn-link btn-sm" @click="filtering = 'progress'" :class="{ 'active': filtering === 'progress'}">{{t('user.page.table.bets.btn.progress')}}</div>
					<div class="btn btn-link btn-sm" @click="filtering = 'end'" :class="{ 'active': filtering === 'end'}">{{t('user.page.table.bets.btn.ended')}}</div>
				</div>
			</div>

			<div class="table-wrapper">
				<table class="table table-striped account__table account__table--bets"
					   v-if="pageCount"
					   :class="{ 'account__table--complex' : !isSimple  }">
					<thead class="thead-dark">
					<tr>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.bets.id') }}</th>
						<th scope="col">{{ t('user.page.table.bets.date') }}</th>
						<th scope="col">{{ t('user.page.table.bets.race') }}</th>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.bets.bettype') }}</th>
						<th scope="col">{{ t('user.page.table.bets.bet') }}</th>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.bets.benefit') }}</th>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.bets.stake') }}</th>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.bets.status') }}</th>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.bets.formula') }}</th>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.bets.cancel') }}</th>
					</tr>
					</thead>

					<!-- Define table columns output -->
					<!--SIMPLE-->
					<tbody v-if="isSimple">
					<tr :key="'bet-'+bet.id" v-for="bet in betsPage">
						<td v-html="betDateString(bet.created)"></td>
						<td>{{ bet.trackname }} <br>
                     <game
                        :bet="{
                           code: bet.wagetype,
                           booster: bet.booster
                        }"
                         :iconed="false"
                     />
                  </td>
						<td>{{formatToMoney(bet.totalamount)}}</td>
					</tr>
					</tbody>
					<!--COMPLEX-->
					<tbody v-else>
					<tr :key="'bet-'+bet.id" v-for="bet in betsPage">
						<th scope="row">
							<span class="pointer btn btn-link btn-sm btn-open-details" @click="detailsId = bet.id">
								{{bet.id}}
							</span>
						</th>
						<td v-html="betDateString(bet.created)"></td>
						<td>
							<router-link :to="{name: 'RaceById', params: { 'race_id': bet.race_id}}">R{{bet.cardnr}}C{{bet.racenr}} {{ bet.trackname }}</router-link>
						</td>
						<td>
							<game
                         :bet="{
                           code: bet.wagetype,
                           booster: bet.booster
                        }"
                         iconed
                     />
						</td>
						<td>
							{{formatToMoney(bet.totalamount)}}
						</td>
						<td>{{formatToMoney(bet.winamount)}}</td>
						<td>{{formatToMoney(bet.stakeamount)}}</td>
						<td>{{t('bet.status.'+bet.status)}}</td>
						<td>{{bet.leg}}</td>
						<td>
							<i class="fa fa-trash pointer" v-if="isCancelAvailable(bet)" @click="cancelBet(bet)" :title="t('user.page.table.bets.cancel.btn')">

							</i>
						</td>
					</tr>
					</tbody>
				</table>
			</div>

			<div class="row">
				<div class="col-12">
					<paginate v-if="pageCount && !simple"
							  v-model="page"
							  :page-count="pageCount"
							  :page-range="3"
							  :margin-pages="2"
							  :prev-text="tPrev"
							  :next-text="tNext"
							  :page-link-class="'page-link'"
							  :container-class="'pagination mb-0 justify-content-center'"
							  :page-class="'page-item'"
							  :prev-link-class="'page-link'"
							  :prev-class="'page-item'"
							  :next-link-class="'page-link'"
							  :next-class="'page-item'"
					>
					</paginate>
				</div>
			</div>
			<div class="row" v-if="!pageCount">
				<div class="col-12">
					<div class="jumbotron">
						<h2 class="display-6">{{t('user.page.bets.no-bets')}}</h2>
					</div>
				</div>
			</div>
			<div class="row" v-if="pageCount > 1 && simple">
				<div class="col-12">
					<router-link :to="{name: 'UserBets'}" class="btn btn-secondary">{{t('user.page.bets.showmore')}}</router-link>
				</div>
			</div>
		</div>

		<bet-cancel-modal @update="update" :bet="toCancel" @close="toCancel = null"></bet-cancel-modal>

		<!--Bet details modal-->
		<modal v-if="detailsId !== null && detailedBet" :size="'md'" @close="closeDetails">
			<div slot="body" >
				<div class="row">
					<div class="col-12 col-md-6">

						<div class="list-group">
							<!--<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">{{ t('user.page.table.bets.date') }}</h5>
								</div>
								<p class="mb-1" v-html="betDateString(detailedBet.created)">

								</p>
							</div>-->
							<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">{{ t('user.page.table.bets.date.dtl') }}</h5>

								</div>
								<p class="mb-1" v-html="betDateString(detailedBet.racedate)">

								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">{{ t('user.page.table.bets.id') }}</h5>
								</div>
								<p class="mb-1">
									{{detailedBet.id}}
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">{{ t('user.page.table.bets.race') }}</h5>
								</div>
								<p class="mb-1">
									<router-link :to="{name: 'RaceById', params: { 'race_id': detailedBet.race_id}}">R{{detailedBet.cardnr}}C{{detailedBet.racenr}} {{ detailedBet.trackname }}</router-link>
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">
										{{ t('user.page.table.bets.bettype') }}
									</h5>
								</div>
								<p class="mb-1">
                           <game
                               :bet="{
                                    code: detailedBet.wagetype,
                                    booster: detailedBet.booster
                                 }"
                               iconed
                           />
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">
										{{ t('user.page.table.bets.status') }}
									</h5>
								</div>
								<p class="mb-1">
									{{t('bet.status.'+detailedBet.status)}}
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start" v-if="detailedBet.multiplier">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">{{t('user.page.table.bets.multiplier')}}</h5>
								</div>
								<p class="mb-1">
									x{{detailedBet.multiplier/100}}
								</p>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-6">

						<div class="list-group">
							<div class="list-group-item list-group-item-action flex-column align-items-start" v-if="detailedBet.flexi !== null">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">{{t('user.page.bets.flexi')}}</h5>
								</div>
								<p class="mb-1">
									<span v-if="detailedBet.flexi == 100">
										{{t('user.page.bets.flexi.base')}}
									</span>
									<span v-else>
										{{t('racecard.bet.box.flexi.'+detailedBet.flexi)}}
									</span>
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">{{ t('user.page.table.bets.formula') }}</h5>
								</div>
								<p class="mb-1">
									{{detailedBet.leg}}
								</p>
								<p v-if="detailedBet.boxed">
									<t tag="racecard.bet.dtlo"/>
								</p>
								<p v-if="detailedBet.non_runners">
									<t tag="user.page.table.bets.nonrunners"/>: {{detailedBet.non_runners}}
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">{{ t('user.page.table.bets.bet') }}</h5>
								</div>
								<p class="mb-1">
									{{formatToMoney(detailedBet.totalamount)}}
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">
										{{ t('user.page.table.bets.benefit') }}
									</h5>
								</div>
								<p class="mb-1">
									{{formatToMoney(detailedBet.winamount)}}
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1"><t tag="user.page.table.bets.stake"/></h5>
								</div>
								<p class="mb-1">
									{{formatToMoney(detailedBet.stakeamount)}}
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start" v-if="multiplier">
								<div class="d-flex w-100 justify-content-between">
									<h5 class="mb-1">{{t('user.page.table.bets.engaged')}}</h5>
								</div>
								<p class="mb-1">
									{{formatToMoney(totalAmount(detailedBet.totalamount, detailedBet.wagetype) )}}
								</p>
							</div>
							<div class="list-group-item list-group-item-action flex-column align-items-start" v-if="!detailedBet.multiplier">
								<div class="d-flex w-100 justify-content-between">

								</div>
								<p class="mb-1" v-if="isCancelAvailable(detailedBet)">
									<button class="btn btn-secondary btn-xs"  @click="cancelBet(detailedBet)">{{t('user.page.table.bets.cancel.btn')}}</button>
								</p>
								<p class="mb-1" v-else>
									<small>
										{{t('user.page.table.bets.cancel.not.available')}}
									</small>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>
<script>
	import Vuex from 'vuex';
	import DatePicker from 'vue2-datepicker';
	import Paginate from 'vuejs-paginate';
	import BetCancelModal from '@/components/user/UserBetCancel';
	import moment from 'moment-timezone';
	import Modal from '@/components/parts/modal';

	//TODO: in Datepicker v.3 that should be fixed by plugin author
	DatePicker.fecha.i18n.monthNames = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];


	export default {
		name: 'bets-table',
		components: {
			DatePicker,
			Paginate,
			BetCancelModal,
			Modal
		},
		props: ['simple'],
		data() {
			return {

				detailsId: null,
				toCancel: null,
				date: [
				],
				page: 1,
				pagelength: 10,
				tPrev: '«',
				tNext: '»',
				filtering: 'all', // all/progress/end
				/*betStatuses: {
					0:"Status open still",
					80:"Bet accepted",
					81:"Track not open yet",
					82:"Invalid bet",
					83:"Raceday not open yet",
					84:"Betting not possible (anymore)",
					85:"Scratched horse",
					86:"Horse selection not valid",
					87:"Wrong stake",
					88:"Invalid stake",
					89:"Wrong account number",
					90:"Race already started",
					91:"No ticketnumber left",
					92:"Sale stopped",
					93:"Broken tote connection",
					94:"Not confirmed by tote",
					95:"No cancellations for this race possible",
					96:"Race in evaluation",
					97:"Race closed",
					98:"Combined bets failed",
					99:"Rejected by central",
					100:"Bet won",
					101:"Bet lost",
					102:"Bet cancelled",
				}*/
			}
		},
		computed:{
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				user: 'getUser',
				userLogedIn: 'getUserStatus'
			}),
			isSimple(){

				return typeof this.simple !== 'undefined'
					?
					this.simple
					:
					false;
			},
			from:{
				get(){
					return this.$store.state.user.bets.from;
				}
			},
			to:{
				get(){
					return this.$store.state.user.bets.to;
				}
			},
			bets(){

				let filtered;

				if(this.filtering === 'all'){
					//show all bets
					filtered = this.$store.getters.getBets;
				}else{
					//Filter by parameters
					filtered = this.$store.getters.getBets.filter((bet)=>{
						switch (this.filtering){

							case('progress'):
								return this.isProgress(bet);

							case('end'):
								return this.isEnded(bet);
						}
					});
				}
				return filtered;
			},
			detailedBet(){
				return this.bets.find((bet)=> bet.id === this.detailsId );
			},
			betsPage(){
				let pp = this.page -1;




				//Slice to pages
				return this.bets.slice(pp*this.pagelength,  pp*this.pagelength + this.pagelength);
			},
			pageCount(){
				return Math.ceil(this.bets.length / this.pagelength );
			},
			pathBetId(){
				return this.$route.params.betId;
			},
			multiplier(){
				if(this.detailedBet && !isNaN(this.detailedBet.multiplier)){
					return this.detailedBet.multiplier / 100;
				}

				return null;
			},
			rules(){
				//return all bet types rules
				return this.$store.state.race.rules;
			}
		},
		watch: {
			date: {
				handler(val){

					if(typeof val === 'object' && val.length === 2){


						this.$store.commit('setUserBetsFromTo', {
							from: val[0],
							to: val[1],
							limit: ''
						});

					}

				},
				deep: true
			},
			bets(){
				this.page = 1;
			},
			simple(){
				this.checkSimple();
			}
		},
		mounted(){
			if(this.from !== '' && this.to !== ''){
				this.date = [
					moment(this.from).toDate(),
					moment(this.to).toDate()
				];
			}

			if(this.$route.name === 'UserBetsWithId' && this.pathBetId){
				//this.detailsId = parseInt(this.pathBetId);  //disabled by PMCLNL-371
			}
			this.checkSimple();

		},
		methods:{
			/*betStatus(bet){
				let status = {
					ended: this.isEnded(bet),
					progress: false
				};


			},*/
			isEnded(bet){
				return bet.status === 84 || bet.status === 96 || bet.status === 97 || bet.status === 100 || bet.status === 101 || bet.status === 102;
			},
			isProgress(bet){
				return bet.status === 0 || bet.status === 80 || bet.status === 90 || bet.status === 96;
			},

			checkSimple(){
				//Check if we show preview with list limit 10, or we should show full list
				let params = {
					from: '',
					to: '',
					limit: ''
				};
				if(!this.simple || (this.from !== '' && this.to !== '')){
					this.pagelength = 15;
					params.from = this.from || '';
					params.to = this.to || '';
				}else{
					//Simply show 10 last bets
					params.limit = 10;
				}

				this.$store.commit('setUserBetsFromTo', params);
			},
			update(){
				this.$store.dispatch('getUserBets');

			},
			betDateString(date){
				date = moment(date);

				let format = this.isSimple ? 'DD/MM' : 'DD/MM/YYYY';
				let br = this.isSimple ? '<br>' : '';

				return `${date.format(format)}
				${br}
				${this.formatToTime(date)}`;
			},


			cancelBet(bet){
				this.toCancel = bet;
			},

			isCancelAvailable(bet){

				//bet.status === 80 &&
				const gap = 15*1000*60;  //15 minutes
				const now = moment().valueOf();

				return bet.race_status === 'OPEN' && ( now - moment(bet.created).valueOf() ) <= gap  && bet.status === 80  && !(/jackpot/gi.test(bet.wagetype)) && (moment(bet.racedate).valueOf() > now);
			},


			closeDetails(){
				this.detailsId = null;
			},
			totalAmount(totalAmount, code){
				const rule = this.rules.find((r) => {
					return r.name === code;
				});

				if(rule){
					const params = {
						jackpot_coefficient: 0.75,
						...rule.param,
					}


					return totalAmount * params.jackpot_coefficient;
				}

				return totalAmount * 0.75;
			}
		}
	}
</script>
<style lang="scss">

	.btn-open-details{
		&:hover{
			color: #0b7e91;
		}
	}
</style>
